module.exports = __webpack_public_path__ + "static/img/2.705e6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2.png
// module id = FSDn
// module chunks = 0